import { useEffect } from "react";
import useScreenSize from "./use-screen-size";

const useLockBodyScroll = (lock: boolean): void => {
  const { isMobile } = useScreenSize();

  useEffect(() => {
    if (lock && isMobile) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [lock, isMobile]);
};

export default useLockBodyScroll;
